import "./NoListProv.css";

const NoListProv = ({ title, Icon }) => {
  /*Los props van en Titulo y Icono*/
  return (
    <div className="boxnotdatalistprov">
      <div>
        <Icon className="Nolistprovlist" />
      </div>
      <div className="boxtittlelisprov">
        <p className="tittlenotdatalistprov">{title}</p>
      </div>
      <div className="boxexplainnotdatalistprov">
        <p className="explainotdatalistprov">
          No tiene facturas cargadas de este mes.
        </p>
      </div>
    </div>
  );
};

export default NoListProv;
